import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Guía de Supervivencia Hospitalaria',
  desc: 'Signos vitales, alarmas, UTI, documentación clínica y primeros días en sala.',
  price: '$12.000'
}, {
  num: '02',
  title: 'Fichas de Evaluación Kinésica',
  desc: 'Modelos de evaluación por región con el formato que piden los docentes.',
  price: '$9.000'
}, {
  num: '03',
  title: 'Mnemotecnias de Anatomía y Clínica',
  desc: 'Memoria visual para nervios, músculos, inserciones y síndromes.',
  price: '$10.000'
}, {
  num: '04',
  title: 'Signos Vitales y Valores de Alarma',
  desc: 'Valores de referencia, escalas clínicas e interpretación de parámetros.',
  price: '$9.000'
}, {
  num: '05',
  title: 'Guía Definitiva de Finales',
  desc: 'Preguntas frecuentes de parciales y finales con respuestas desarrolladas.',
  price: '$8.000'
}, {
  num: '06',
  title: 'Cómo Empezar a Trabajar como Kinesiólogo',
  desc: 'Primeras consultas, historia clínica y consejos para el ejercicio profesional.',
  price: '$10.000'
}];
export function Bonuses() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(239,246,255) 50%, rgb(219,234,254) 100%)'
  }} data-id="element-50">
      <div className="mx-auto max-w-4xl" data-id="element-51">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-52">
          Más los <span className="text-blue-700" data-id="element-53">6 Bonos Exclusivos</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-54">
          Armados por kinesiólogos y docentes — incluidos siempre
        </p>

        {/* Bonus List */}
        <div className="bg-white border border-blue-700/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-55">
          <div className="bg-blue-700 px-5 py-2.5" data-id="element-56">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-57">
              🎁 LOS 6 BONOS — Incluidos siempre
            </h3>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-58">
            {bonuses.map(bonus => <div key={bonus.num} className="flex items-center gap-4 px-5 py-2" data-id="element-59">
                <span className="shrink-0 text-lg font-black text-blue-700/30 w-8 text-center" data-id="element-60">
                  {bonus.num}
                </span>
                <div className="flex-1 min-w-0" data-id="element-61">
                  <span className="block text-sm font-black text-gray-900" data-id="element-62">
                    {bonus.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-63">
                    {bonus.desc}
                  </span>
                </div>
                <div className="shrink-0 flex flex-col items-end gap-0.5" data-id="element-64">
                  <span className="text-[10px] text-gray-400 line-through" data-id="element-65">
                    {bonus.price}
                  </span>
                  <span className="text-[10px] font-black text-white bg-blue-700 rounded-full px-2 py-0.5" data-id="element-66">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Total Value Footer */}
        <div className="text-center rounded-xl px-5 py-3 shadow-sm" style={{
        backgroundColor: 'rgb(239,246,255)',
        border: '1px solid rgba(59,130,246,0.3)'
      }} data-id="element-67">
          <p className="text-xs font-bold uppercase tracking-widest text-blue-700 m-0 mb-1" data-id="element-68">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3" data-id="element-69">
            <span className="text-base text-gray-400 line-through" data-id="element-70">
              $58.000
            </span>
            <span className="text-lg font-black text-blue-700" data-id="element-71">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
        </div>
      </div>
    </section>;
}